import { useEffect, useRef }                  from 'react';
import { useSelector, useDispatch }           from "react-redux";
import { fetchUnreads, teleconsultSelector }  from 'app/teleconsultSlice';

export function NotificationBatch() {
  const dispatch = useDispatch();
  const isCancelled = useRef(false);
  const { unread_count } = useSelector(teleconsultSelector)

  useEffect(() => {
    dispatch(fetchUnreads())
    return () => {
      isCancelled.current = true;
    };
  }, [dispatch]); // eslint-disable-line

  return (
    unread_count > 0 ? <span className="side-notification-badge">{unread_count}</span> : null
  );
}

export default NotificationBatch;